import "core-js/modules/es.array.push.js";
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      paths: [{
        name: "Профиль",
        path: "/rol-shop/profile"
      }, {
        name: "История заказов",
        path: "/rol-shop/profile/history"
      }],
      ordersComplete: [],
      ordersProcess: [],
      activeItem1: 0,
      activeItem2: "",
      loadingOrders: false,
      loadingTips: false
    };
  },
  methods: {
    ...mapActions({
      dateFormat: "date/dateFormat"
    }),
    ...mapMutations({
      setPaths: "crumbs/setPaths"
    }),
    async fetchOrders() {
      let apiRes = null;
      try {
        this.loadingOrders = true;
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/orders?sortBy=-id`);
        this.ordersComplete = data.filter(order => order.status === 5);
        this.ordersProcess = data.filter(order => order.status !== 5);
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        if (apiRes == 404) {
          this.$router.push('/rol-shop/404');
        }
      }
    },
    async fetchTips() {
      let apiRes = null;
      try {
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/tips`);
        this.ordersProcess = this.ordersProcess.map(order => {
          const tips = data.find(item => item.orders_id === order.id);
          if (!tips) {
            return {
              ...order,
              tips: false
            };
          }
          return {
            ...order,
            tips: true
          };
        });
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        this.loadingOrders = false;
        if (apiRes == 404) {
          this.$router.push('/rol-shop/404');
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.setPaths(vm.paths);
    });
  },
  computed: {
    ...mapState({})
  },
  mounted() {
    this.fetchOrders().then(() => {
      this.fetchTips();
    });
  }
};